/**
 * YouTube API 서비스
 */

import { apiClient } from '../../../shared/services/api';

export interface YouTubeVideo {
  title: string;
  thumbnailUrl: string;
  videoUrl: string;
  regDt: string;
}

export interface YouTubeResponse {
  prevPageToken?: string;
  nextPageToken?: string;
  videoList: YouTubeVideo[];
}

export type PlaylistType = 'sunday-morning' | 'sunday-evening' | 'wednesday' | 'dawn' | 'friday';

export const youtubeService = {
  /**
   * 유튜브 비디오 목록 조회
   */
  getVideos: async (playlistType: PlaylistType, pageToken: string = ''): Promise<YouTubeResponse> => {
    const url = pageToken
      ? `/youtube/${playlistType}?pageToken=${pageToken}`
      : `/youtube/${playlistType}`;
    const response = await apiClient.get<{ data: YouTubeResponse }>(url);
    return response.data;
  },
};
